import React from 'react'
import { Checkbox, Input, Popup, Radio, RichTextEditor, Textarea, FroalaTextEditor } from 'components/UIElements'
import { formatStringForID } from 'utils/misc'

const _getInputType = (error, fieldInfo, isClinro, onUpdate, value, isReadOnlyState, metadataKey) => {
  const { text } = fieldInfo
  const id = formatStringForID(text)

  switch (fieldInfo.type) {
    case 'checkbox': {
      return (
        <div className='checkbox-wrapper'>
          <Checkbox
            id={id}
            label={fieldInfo.label}
            checked={value}
            onClick={() => {
              onUpdate(!value)
            }}
            disabled={isReadOnlyState}
          />
          <p>{fieldInfo.bodyText}</p>
        </div>
      )
    }
    case 'input':
    case 'number':
      return (
        <Input
          id={id}
          className={`${fieldInfo.type === 'number' ? 'num-input' : ''}${error ? ' has-error' : ''}`}
          value={value}
          type={fieldInfo.type === 'number' ? 'number' : undefined}
          onChange={onUpdate}
          min={0}
          step={1}
          disabled={isReadOnlyState}
        />
      )
    case 'radio': {
      const effectiveValue = value === undefined ? fieldInfo.defaultValue : value
      const radios = fieldInfo.options.map(option => {
        return (
          <Radio
            id={`${id}-${option.key}`}
            content={option.text}
            onClick={() => onUpdate(option.value)}
            key={option.key}
            selected={effectiveValue === option.value}
            disabled={isReadOnlyState}
          />
        )
      })
      const questionLabel = fieldInfo.question ? (
        <div className='property-field radio-question'>
          <span>{fieldInfo.question}</span>
        </div>
      ) : null
      if (fieldInfo.inline) {
        return (
          <div>
            {questionLabel}
            <div className='property-field radio-inline'>{radios}</div>
          </div>
        )
      }
      return (
        <div>
          {questionLabel}
          <div>{radios}</div>
        </div>
      )
    }
    case 'textarea':
      return <Textarea id={id} value={value} onChange={onUpdate} disabled={isReadOnlyState} />
    case 'texteditor':
      // Copyright text field should have a 250 character limit
      const charLimit = metadataKey === 'copyright_text' ? 250 : 100
      return (
        <>
          <FroalaTextEditor
            value={value}
            onChange={onUpdate}
            readOnly={isReadOnlyState}
            showToolbar
            charLimit={charLimit}
            moreText={{
              includeAll: true,
            }}
            moreParagraph={{
              includeAll: true,
            }}
            moreRich={{
              buttons: ['specialCharacters'],
              includeAll: false,
            }}
          />
        </>
      )
    default:
      return null
  }
}
const PropertyField = ({ error, fieldInfo, metadataKey, isClinro, onUpdate, value, isReadOnlyState }) => {
  return (
    <div className='property-field'>
      <TooltipLabel {...fieldInfo} error={error} />
      {_getInputType(error, fieldInfo, isClinro, onUpdate, value, isReadOnlyState, metadataKey)}
    </div >
  )
}

export const TooltipLabel = ({ error, text, description, type, noTooltip }) => {
  return (
    <div className={`flexed-header${type === 'number' ? ' num' : ''}`}>
      <span className='label-small' style={{ color: error ? 'red' : undefined }}>
        {text}
      </span>
      {!noTooltip && (
        <Popup position='right' trigger={<i className='fas fa-info-circle' />}>
          <p>{description}</p>
        </Popup>
      )}
    </div>
  )
}

export default PropertyField
